export default __webpack_public_path__ + "static/media/phoneW.ce33d8f1.svg";